export default __webpack_public_path__ + "static/media/warehouse-10 1.f941d732.jpg";